/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duration_1_DayInputs */

const en_duration_1_day = /** @type {(inputs: Duration_1_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Day`)
};

const es_duration_1_day = /** @type {(inputs: Duration_1_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 dia`)
};

/**
* | output |
* | --- |
* | "1 Day" |
*
* @param {Duration_1_DayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const duration_1_day = /** @type {((inputs?: Duration_1_DayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_1_DayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duration_1_day(inputs)
	return es_duration_1_day(inputs)
});